import { RESOURCE_TYPE } from './CONSTANTS';

const isInternalLink = (externalResource) => {
    const validTypes = [RESOURCE_TYPE.TETTRA_PAGE, RESOURCE_TYPE.TETTRA_QUESTION, RESOURCE_TYPE.TETTRA_PDF];
    return validTypes.includes(externalResource.type);
}

export {
    isInternalLink
}
